import { optionsToStrategy } from '@/common/utils/optionsToStrategy'

export const printerMachinesTasksStatusOptions = [
  { value: 'in_progress', label: 'Tarefa em andamento' },
  { value: 'complete', label: 'Completa' },
  { value: 'failed', label: 'Falha' }
]

export const printerMachinesTasksStrategy = optionsToStrategy(printerMachinesTasksStatusOptions);